import { Button, List, Switch, Typography, Space, ColorPicker } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import useSceneStore from '../../stores/sceneStore';

const { Text } = Typography;

export default function FlyLinePanel() {
  const { flyLines, addFlyLine, updateFlyLine, removeFlyLine } = useSceneStore();

  return (
    <div style={{ padding: 12 }}>
      <Space style={{ width: '100%', justifyContent: 'space-between', marginBottom: 8 }}>
        <Text strong style={{ fontSize: 13 }}>飞线</Text>
        <Button size="small" type="primary" icon={<PlusOutlined />}
          onClick={() => addFlyLine({
            name: `飞线 ${flyLines.length + 1}`,
            sceneId: '',
            from: [0, 5, 0],
            to: [10, 5, 0],
            color: '#1890ff',
            width: 1,
            speed: 1,
            visible: true,
          })}
        />
      </Space>

      <List
        dataSource={flyLines}
        locale={{ emptyText: '暂无飞线' }}
        renderItem={(line) => (
          <List.Item style={{ padding: '6px 0' }}>
            <Space style={{ width: '100%' }}>
              <Switch size="small" checked={line.visible}
                onChange={(v) => updateFlyLine(line.id, { visible: v })} />
              <Text style={{ fontSize: 12, flex: 1 }}>{line.name}</Text>
              <ColorPicker size="small" value={line.color}
                onChange={(c) => updateFlyLine(line.id, { color: c.toHexString() })} />
              <Button type="text" size="small" danger icon={<DeleteOutlined />}
                onClick={() => removeFlyLine(line.id)} />
            </Space>
          </List.Item>
        )}
      />
    </div>
  );
}
